<cyborg-section id="search-results">
  <cyborg-error-message
    class="error"
    *ngIf="searchStateService.resultsError | async; else loading"
  >
    <strong>HUNTER has encountered an error.</strong> Please return to
    <a routerLink="/research">Research</a> or contact
    <a routerLink="/customer-support">support</a>.
  </cyborg-error-message>

  <ng-template #loading>
    <div
      class="loading"
      *ngIf="searchStateService.resultsLoading | async; else results"
    >
      <kendo-loader type="pulsing" themeColor="primary" size="large">
      </kendo-loader>
    </div>
  </ng-template>

  <ng-template #results>
    <div *ngIf="searchStateService.results | async as results">
      <div class="results-header">
        <div class="result-logo">
          <hyperkit-typography variant="h5" align="left" color="primary">
            {{ results.data.total }} Result<span *ngIf="results.data.total != 1"
              >s</span
            ></hyperkit-typography
          >
        </div>
        <div class="toolbar">
          <cyborg-search-sort></cyborg-search-sort>
        </div>
      </div>

      <!-- Render appropriate sub-component based on result type-->
      <div *ngFor="let result of results.data.results">
        <hunt-package
          *ngIf="searchDataService.isHuntPack(result)"
          [data]="result"
        ></hunt-package>
        <threat-profiles
          *ngIf="searchDataService.isThreatProfile(result)"
          [data]="result"
        >
        </threat-profiles>
        <cyborg-collection
          *ngIf="searchDataService.isCollection(result)"
          [data]="result"
          [highlighting]="true"
        >
        </cyborg-collection>
      </div>
      <kendo-datapager
        [style.width.%]="100"
        [pageSize]="pageSize"
        [skip]="skip"
        [total]="results.data.total"
        [pageSizeValues]="false"
        (pageChange)="onPageChange($event)"
      >
      </kendo-datapager>
    </div>
  </ng-template>
</cyborg-section>
